import React from 'react';
import { VertContainer, VertSkeleton } from '@vertem-core/vertice-ds';
import MediaQuery from 'react-responsive';

const CategoryPlaceholder = () => {
  const ItemsPlaceholder = () => {
    const items = [];
    /* eslint-disable */
    for (let i = 0; i <= 10; i++) {
      items.push(
        <div
          style={{
            width: '10%',
          }}
        >
          <VertSkeleton.Button active size="small" shape="round" block />
        </div>,
      );
    }
    return items;
  };

  return (
    <VertContainer className="vert-box-chips  margin-bottom-regular" spacingX="big">
      <div className="category-chips-menu-container-desktop">
        <div className="category-chips-menu-content">
          <MediaQuery
            minWidth={769}
          >
            <div
              style={{
                display: 'flex',
                gap: '16px',
                width: '100%',
              }}
            >
              <ItemsPlaceholder />
            </div>
          </MediaQuery>
          <MediaQuery
            maxWidth={768}
          >
            <div
              style={{
                display: 'flex',
                gap: '16px',
                width: '100%',
              }}
            >
              <div
                style={{
                  width: '100%',
                }}
              >
                <VertSkeleton.Button active size="small" shape="round" block />
              </div>
            </div>
          </MediaQuery>
        </div>
      </div>
    </VertContainer>
  );
};

export default CategoryPlaceholder;
